const state = {
    IsViewImage : false,
    ActiveImageIndex : 0
}

const getters = {
    IsViewImage :(state) => state.IsViewImage,
    ActiveImageIndex :(state) => state.ActiveImageIndex
}

const actions = {
    setImageView({commit}, bool) {
        commit('setImageView', bool)
    },
    setActiveImageIndex({commit}, Index) {
        commit('setActiveImageIndex', Index)
    }
}

const mutations = {
    setImageView(state, bool) {
        state.IsViewImage = bool
    },
    setActiveImageIndex(state, Index) {
        state.ActiveImageIndex = Index
    }
}

export default {
    namespaced : true,
    state,
    getters,
    actions,
    mutations
}

